var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6654 12.3337C22.6654 20.3337 11.9987 28.3337 11.9987 28.3337C11.9987 28.3337 1.33203 20.3337 1.33203 12.3337C1.33203 9.50468 2.45584 6.79157 4.45623 4.79119C6.45661 2.7908 9.16972 1.66699 11.9987 1.66699C14.8277 1.66699 17.5408 2.7908 19.5412 4.79119C21.5416 6.79157 22.6654 9.50468 22.6654 12.3337Z",
    stroke: "#227B2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 16.3337C14.2078 16.3337 15.9987 14.5428 15.9987 12.3337C15.9987 10.1245 14.2078 8.33366 11.9987 8.33366C9.78956 8.33366 7.9987 10.1245 7.9987 12.3337C7.9987 14.5428 9.78956 16.3337 11.9987 16.3337Z",
    stroke: "#227B2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon2);
export default __webpack_public_path__ + "static/media/location-icon-2.c48bbbc48a72aefc477e57f7962720cf.svg";
export { ForwardRef as ReactComponent };